var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvaLogoDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 6.99995C27 3.13402 23.866 0 19.9999 0C16.134 0 13 3.13402 13 6.99995C13 10.866 16.134 14 19.9999 14H27V6.99995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.38419e-07 15C-2.38419e-07 11.134 3.13401 8 7.00005 8C10.866 8 14 11.134 14 15C14 18.866 10.866 22 7.00005 22H-2.38419e-07V15Z",
    fill: "#EB6087"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvaLogoDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ava-logo-dark.9c27cd89b8ff85675f39bd918bd47cf3.svg";